module.exports = __webpack_public_path__ + "static/media/SPRAY-PLAYER.7f1ac784.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/SPRAY-PLAYER.png
// module id = 281
// module chunks = 0